import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { useEffect, useState } from "react";
import { fetchProdotti } from "../../../features/Prodotti/prodottiThunk"; // Import the fetchProdotti action
import { fetchCompanies } from "../../../features/company/companyThunk";

const Prodotti = () => {
  const dispatch = useDispatch(); // Dispatch hook
    const prodotti = useSelector((state) => state.prodotto?.prodotti);
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const loading = useSelector((state) => state.prodotto?.loading); // You might want to track loading status too

  const columns = [
    { field: "nomeProdotto", headerName: "Nome del prodotto", width: 296 },
    { field: "tipo", headerName: "Tipo", width: 189 },
    { field: "tipologia", headerName: "Tipologia", width: 189 },
    { field: "annoProduzione", headerName: "Anno di Produzione", width: 189 },
    { field: "gradazioneAlcolica", headerName: "Gradazione Alcolica", width: 189 },
    { field: "cod", headerName: "Cod.", width: 174 },
    { field: "codEan", headerName: "Cod. EAN", width: 174 },
    { field: "denominazione", headerName: "Denominazione", width: 174 },
    { field: "azioni", headerName: "Azioni", width: 120, sortable: false },
  ];

  const [tableRows, setTableRows] = useState([]);

  // Fetch prodotti on component mount
  useEffect(() => {
  
      dispatch(fetchProdotti()); // Dispatch the fetchProdotti action to get the data
    
  }, [dispatch, selectSelectedCompany]);
  
  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  useEffect(() => {
    if (prodotti && prodotti.length > 0) {
      console.log(prodotti);
      
      const mappedData = prodotti.map((item) => ({
        id: item.id,
        nomeProdotto: item.commercial_name,
        tipo: item.tipo,
        tipologia: item.tipologia,
        annoProduzione: item.anno_di_produzione,
        gradazioneAlcolica: item.gradazione_alcolica,
        cod: item.product_code,
        codEan: item.ean_code,
        denominazione: item.denominazione?.toUpperCase(),
      }));
      setTableRows(mappedData);
    }
  }, [prodotti]);

  return (
    <div className="pageTemplate">
      {loading ? (
        <div>Loading...</div> // You can show a loading spinner or message while fetching data
      ) : (
        <Table
          data={tableRows}
          columns={columns}
          navData={"structureProdotti"}
          deleteFunctions={"deleteProdottoData"}
        />
      )}
    </div>
  );
};

export default Prodotti;
